module.exports = __webpack_public_path__ + "static/media/hbb_grid_1.e9179c25.png";